import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <main className="mx-auto flex max-w-md flex-col px-4 py-16 sm:py-24">
      <Link
        to="/accedi"
        data-testid="forgot-back-to-login"
        className="mb-8 flex items-center gap-2 text-sm font-semibold text-[#8C7B6E] transition-colors hover:text-[#B85328]"
      >
        <ArrowLeft size={15} /> Torna all'accesso
      </Link>
      <div className="text-center">
        <p className="eyebrow justify-center">Recupero password</p>
        <h1 data-testid="forgot-heading" className="font-display mt-3 text-3xl font-semibold text-[#2C2723] sm:text-4xl">
          Password <span className="italic text-[#B85328]">dimenticata?</span>
        </h1>
        <p className="mt-3 text-sm text-[#8C7B6E]">
          Inserisci la tua email: ti invieremo un link per scegliere una nuova password.
        </p>
      </div>

      <div className="mt-8 rounded-3xl border border-[#E8DFD5] bg-white p-7 shadow-sm sm:p-9">
        {sent ? (
          <div data-testid="forgot-success-message" className="text-center">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#EAF0ED] text-[#4A6B5D]">
              <Mail size={24} />
            </span>
            <p className="font-display mt-5 text-2xl font-semibold text-[#2C2723]">Controlla la tua casella</p>
            <p className="mt-3 text-sm leading-relaxed text-[#5C534B]">
              Se l'email è registrata, riceverai entro pochi minuti il link per reimpostare la
              password. Il link è valido per 1 ora.
            </p>
          </div>
        ) : (
          <form data-testid="forgot-form" onSubmit={submit} className="space-y-4">
            <input
              data-testid="forgot-input-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="La tua email"
              className="w-full rounded-xl border border-[#E8DFD5] bg-[#FBF8F3] px-4 py-3.5 text-sm text-[#2C2723] outline-none transition-all duration-300 placeholder:text-[#8C7B6E]/60 focus:border-[#B85328] focus:ring-2 focus:ring-[#B85328]/15"
            />
            <button
              type="submit"
              data-testid="forgot-submit-button"
              disabled={busy}
              className="w-full rounded-full bg-[#B85328] py-4 text-sm font-semibold text-[#FBF8F3] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#9C421C] hover:shadow-xl disabled:opacity-60"
            >
              {busy ? "Invio in corso..." : "Invia il link di recupero"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
};

export default ForgotPassword;
